<template>
<main id="main-container">
  <!-- Page Content -->
  <div class="row no-gutters flex-md-10-auto">
      <div class="col-md-4 col-lg-5 col-xl-3 order-md-1 bg-white">
          <div class="content p-0">
              <!-- Toggle Settings -->
              <div class="d-md-none p-3">
                  <!-- Class Toggle, functionality initialized in Helpers.coreToggleClass() -->
                  <button type="button" class="btn btn-block btn-hero-primary" data-toggle="class-toggle" data-target="#side-content" data-class="d-none">
                      Cài đặt
                  </button>
              </div>
              <!-- END Toggle Settings -->

              <!-- Settings -->
              <div id="side-content" class="d-none d-md-block push">
                  <div id="settings-accordion" role="tablist" aria-multiselectable="true">
                     <div class="block mb-0">
                                <div class="block-header block-header-default border-top p-0" role="tab" id="settings-accordion_h2">
                                    <a class="font-w600 d-block w-100 p-3" data-toggle="collapse" data-parent="#settings-accordion" href="#settings-accordion_s2" aria-expanded="true" aria-controls="settings-accordion_s2">Danh mục</a>
                                </div>
                                <div id="settings-accordion_s2" class="collapse" role="tabpanel" aria-labelledby="settings-accordion_h2" data-parent="#settings-accordion">
                                    <div class="block-content block-content-full">
                                        <div class="form-group">
                                            <div v-for="(category, cidx) in categories" :key="cidx" class="custom-control custom-radio custom-control-primary mb-1">
                                                <input type="radio" v-model="selectedCategories" class="custom-control-input" :id="'input-cate-' + category.id" name="categories" :value="category.id">
                                                <label class="custom-control-label" :for="'input-cate-' + category.id">{{ category.name }}</label>
                                            </div>
                                        </div>
                                        <!-- <a class="link-fx font-size-sm" href="javascript:void(0)" @click.prevent="createDirectory()">Thêm danh mục mới</a> -->
                                    </div>
                                </div>
                            </div>

                    <div class="block mb-0">
                          <div class="block-header block-header-default border-top p-0" role="tab" id="settings-accordion_h5">
                              <a class="font-w600 d-block w-100 p-3" data-toggle="collapse" data-parent="#settings-accordion" href="#settings-accordion_s5" aria-expanded="true" aria-controls="settings-accordion_s5">Tóm tắt</a>
                          </div>
                          <div id="settings-accordion_s5" class="collapse" role="tabpanel" aria-labelledby="settings-accordion_h5" data-parent="#settings-accordion">
                              <div class="block-content">
                                  <div class="form-group">
                                      <label for="example-wp-excerpt">Nội dung tóm tắt</label>
                                      <textarea v-model="currentForm.summary" class="form-control" id="example-wp-excerpt" name="example-wp-excerpt" rows="4"></textarea>
                                  </div>
                              </div>
                          </div>
                      </div>

                      <div class="block mb-0">
                          <div class="block-header block-header-default border-top p-0" role="tab" id="settings-accordion_h7">
                              <a class="font-w600 d-block w-100 p-3" data-toggle="collapse" data-parent="#settings-accordion" href="#settings-accordion_s7" aria-expanded="true" aria-controls="settings-accordion_s7">SEO</a>
                          </div>
                          <div id="settings-accordion_s7" class="collapse" role="tabpanel" aria-labelledby="settings-accordion_h7" data-parent="#settings-accordion">
                              <div class="block-content">
                                  <div class="form-group">
                                      <label for="txt-description">Meta Description</label>
                                      <div class="font-size-sm text-muted mb-2">Hiển thị thẻ meta description cho sản phẩm</div>
                                      <textarea v-model="currentForm.meta_description" class="form-control" id="txt-description" name="txt-description" rows="4"></textarea>
                                  </div>
                                  <div class="form-group">
                                      <label for="txt-keywords">Meta Keywords</label>
                                      <div class="font-size-sm text-muted mb-2">Những từ khoá cho sản phẩm</div>
                                      <textarea v-model="currentForm.meta_keywords" class="form-control" id="txt-keywords" name="txt-keywords" rows="4"></textarea>
                                  </div>
                              </div>
                          </div>

                      </div>
                  </div>
              </div>
              <!-- END Settings -->
          </div>
      </div>
      <div class="col-md-8 col-lg-7 col-xl-9 order-md-0 bg-body-dark">
          <!-- Main Content -->
          <div class="content content-full">
              <div class="block block-fx-pop">
                  <div class="block-content block-content-full d-flex justify-content-between border-bottom">
                      <div>
                         <nav aria-label="breadcrumb">
                                    <ol class="breadcrumb">
                                      <li style="margin-top: -4px; margin-right: 5px;">
                                        <button type="button" class="btn btn-sm btn-light">
                                            <i class="fa fa-plus"></i>
                                        </button>
                                    </li>
                                    <li class="breadcrumb-item"><router-link :to="'/games'">Game</router-link></li>
                                    <li class="breadcrumb-item active" aria-current="page" v-if="isEdit">Sửa Game / {{currentForm.name}}</li>
                                    <li class="breadcrumb-item active" aria-current="page" v-else>Tạo mới</li>
                                    <!-- <li class="breadcrumb-item active" aria-current="page">Library</li> -->
                                    </ol>
                                </nav>
                      </div>
                      <div>
                          <a class="btn btn-sm btn-info" style="margin-right: 5px;" target="_blank" v-if="isEdit" :href="'/play/' + this.slug">Preview</a>
                          <a class="btn btn-sm btn-info" href="javascript:void(0)" @click.prevent="submitForm">Lưu lại</a>
                      </div>
                      <!-- <div id="preview"><a class="btn btn-sm btn-info" target="_blank" v-if="isEdit" :href="'/preview-game/' + this.slug">Preview</a></div> -->
                  </div>
                  <div class="block-content">
                          <div class="form-group">
                              <input v-model="currentForm.name" type="text" class="form-control py-4" id="post-title" name="post-title" placeholder="Tên ...">
                          </div>
                          <div class="form-group">
                            <input type="text" v-model="slug" class="form-control py-4" id="post-slug" name="post-slug" placeholder="Url ...">
                          </div>

                         <div class="form-group">
                            <textarea v-model="currentForm.link" class="form-control" rows="4" id="setting-value" name="value" placeholder="Link"></textarea>
                         </div>
                         <div class="form-group">
                            <textarea v-model="currentForm.embed" class="form-control" rows="4" id="setting-value" name="value" placeholder="Embed"></textarea>
                         </div>
                         <div class="form-group">

                           <select v-model="selectedType" class="custom-select" id="example-wp-visibility" name="example-wp-visibility">
                              <option v-for="(type, oidx) in listType" :value="type.id" :key="oidx"> {{ type.name}}</option>

                            </select>
                         </div>
                         <div class="form-group">
                            <label>Content</label>
                            <tinymce-tinymce v-model="currentForm.content" :key= "'vue-tinymce-' + currentForm.id" id="example-wp-content" name="example-wp-content"/>
                           </div>
                          <div class="form-group">
                              <label>How to play</label>
                              <tinymce-tinymce v-model="currentForm.description" :key= "'vue-tinymce-' + currentForm.id" id="example-wp-description" name="example-wp-description"/>
                          </div>
                          <div class="form-group">
                            <textarea v-model="currentForm.tag" class="form-control" rows="4" id="setting-value" name="value" placeholder="Tag"></textarea>
                         </div>
                      <div class="form-group">
                        <input type="text" v-model="currentForm.video_preview" class="form-control py-4" id="video_preview" name="video_preview" placeholder="Video URL">
                      </div>
                  </div>
                  <div class="block mb-0">
                          <div class="block-header block-header-default border-top p-0" role="tab" id="settings-accordion_h4">
                              <a class="font-w600 d-block w-100 p-3" data-parent="#settings-accordion" href="#settings-accordion_s4" aria-expanded="true" aria-controls="settings-accordion_s4">Hình đại diện</a>
                          </div>
                          <div id="settings-accordion_s4" role="tabpanel" aria-labelledby="settings-accordion_h4" data-parent="#settings-accordion">
                              <div class="block-content block-content-full" @click="openFileManager('image')">
                                  <input type="hidden" v-model="currentForm.image" />
                                  <div v-if="currentForm.image && currentForm.image != ''">
                                    <img class="img-fluid" :src="currentForm.image" alt="">
                                  </div>
                                  <div v-else class="btn-add-image"> + </div>
                              </div>
                          </div>
                      </div>

              </div>
          </div>
          <!-- END Main Content -->
      </div>
  </div>
  <!-- END Page Content -->
  <add-category :editedIndex="newDirectoryIndex" :editedItem="newDirectoryItem" :slug="newDirectorySlug" @saveSuccess="saveNewDirectorySuccess()" />
 <file-manager-popup />
</main>
<!-- END Main Container -->
</template>

<script>
import { getApi, createApi, updateApi } from '@/api/games'

import { createApi as categoriesCreateApi, listApi as categoriesListApi } from '@/api/categories'


import _ from 'lodash'
import { mapMutations } from 'vuex'
var slugify = require('slugify')

const defaultForm = {
  id: null,
  cate_id: null,
  name: '',
  slug: '',
  type: '',
  link: '',
  embed: '',
  video_preview: '',
  tag:'',
  hits: 0,
  description: '',
  meta_description: '',
  meta_keywords: '',
  categories: []
}

export default {
  name: 'Detail',
  props: {
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  components: {  },
  data() {
    return {
      currentForm: Object.assign({}, defaultForm),
      valid: true,
      loading: false,
      nameRules: [
        v => v.length > 0 || 'Tên không được để trống'
      ],
      slugRules: [
        v => v.length > 0 || 'Url không được để trống',
        v => (/^[a-z0-9](-?[a-z0-9])*$/).test(v) || 'Url không chứa khoảng trắng'
      ],
      panel: [
        false
      ],
      slug: '',
      type:'',
      isAutoSlug: true,
      selectedCategories: '',
      selectedType: '',
      newDirectoryItem: {},
      newDirectoryIndex: -1,
      newDirectorySlug: '',
      categories: [],
    }
  },
  computed: {
     listType: function() {
          return [
            {id: "embed", 'name': 'embed'},
            {id: "link", 'name': 'link'}
          ];

    },
  },
  watch: {
    'currentForm.name': function() {
      if (this.isAutoSlug) {
        this.slug = slugify(_.lowerCase(this.currentForm.name))
      }
    }
  },
  created() {
    if (this.isEdit) {
      const id = this.$route.params && this.$route.params.game
      this.isAutoSlug = false
      this.getData(id)
    } else {
      this.currentForm = Object.assign({}, defaultForm)
    }
    this.listCategories()
    this.listType()
  },
  methods: {
    ...mapMutations('app', ['setSnackbar', 'setMessage']),
    listCategories() {
      categoriesListApi().then(response => {
        this.categories = response
      }).catch(err => {
        console.log(err)
      })
    },
    getData(id) {
      getApi(id).then(response => {
        this.currentForm = response
        this.slug = response.slug
        this.selectedCategories = response.categories.id
        this.selectedType = response.type
      }).catch(err => {
        console.log(err)
      })
    },
    submitFormRequest(data) {
      return new Promise((resolve, reject) => {
        if (this.isEdit) {
          const id = this.$route.params && this.$route.params.game
          updateApi(id, data).then(response => {
            resolve(response)
          }).catch(err => {
            console.log(err)
            reject(err)
          })
        } else {
          createApi(data).then(response => {
            resolve(response)
          }).catch(err => {
            console.log(err)
            reject(err)
          })
        }
      })
    },
    // savePost: function(){
    //   this.$http.post('/play', this.slug)
    //   .success(function(post){
    //   location.href = '/';
    //   });
    // },
    submitForm() {
      // if(this.$refs.currentxForm.validate()) {
          this.loading = true
          this.currentForm.slug = this.slug
          this.currentForm.categories = this.selectedCategories
          this.currentForm.type = this.selectedType

          console.log(this.currentForm);


          this.submitFormRequest(this.currentForm).then((response) => {
            this.loading = false
            Dashmix.helpers('notify', {type: 'success', icon: 'fa fa-success mr-1', message: 'Lưu game thành công.'})
            if (!this.isEdit) {
              this.$router.replace('/games/edit/' + response.id)
            }
          },
          () => {
            this.loading = false
            Dashmix.helpers('notify', {type: 'danger', icon: 'fa fa-times mr-1', message: 'Không lưu được. Vui lòng lưu lại bài viết bằng công cụ khác. Reload và thử lại.'})
          })
      // }
    },

    openFileManager(model) {
      var _this = this;
      window.setFileToElement = function(fileurl, filepath) {
        _this.currentForm[model] = filepath;
        _this.$store.dispatch('file/closeFileManager');
        jQuery('#modal-site-file').modal('hide')
      };
      if (model == 'files') {
        this.$store.dispatch('file/setType', 'Files')
      }
      this.$store.dispatch('file/openFileManager');
      jQuery('#modal-site-file').modal('show')
    },
    createDirectory() {
      this.newDirectoryItem = {
        id: null,
        name: '',
        slug: '',
        create_at: ''
      }
      this.newDirectoryIndex = -1
      this.newDirectorySlug = ''
      jQuery('#modal-add-category').modal('show')
    },
    saveNewDirectorySuccess() {
      jQuery('#modal-add-category').modal('hide')
      this.listCategories()
    },
    //
    createDirectoryBrand(){
      this.newDirectoryItem = {
        id: null,
        name: '',
        slug: '',
        create_at: ''
      }
      this.newDirectoryIndex = -1
      this.newDirectorySlug = ''
      jQuery('#modal-add-brand').modal('show')
    },
    saveNewDirectorySuccessBrand(){
      jQuery('#modal-add-brand').modal('hide')
      this.listBrand()
    }
    //
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .btn-add-image {
    color: #7c7a7a;
    font-size: 79px;
    line-height: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid #ccc;
    height: 100px;
    &.plus-button {
      cursor: pointer;
    }
    &.bg-grey {
      background: #ccc;
    }
  }

  .project-image {
    height: 100px;
    position: relative;
    img {
      width: 100%;
      height: 100px;
      object-fit: cover;
    }
    .image-action {
      position: absolute;
      right: 10px;
      top: 10px;
    }
  }
</style>
